/*
 * MARMOT: лендинг „Ранок" – смяна към „Кампанията приключи" в браузъра,
 * когато страницата е от кеша, а последният ден вече е минал.
 */
(function () {
  'use strict';
  var logic = window.MarmotRanokLogic;
  var page = document.querySelector('[data-marmot-ranok][data-end-ms]');
  if (!logic || !page) return;

  var endMs = page.getAttribute('data-end-ms');

  function swap() {
    var live = page.querySelector('[data-marmot-ranok-live]');
    var ended = page.querySelector('[data-marmot-ranok-ended]');
    if (live) live.remove();
    if (ended) ended.hidden = false;
    page.removeAttribute('data-end-ms');
  }

  if (logic.ranokEnded(endMs, Date.now())) { swap(); return; }

  // Отворена точно преди полунощ – сменя се в момента на края.
  var left = Number(endMs) - Date.now();
  if (left > 0 && left < 86400000) setTimeout(swap, left + 1000);
})();
